<template>
    <div>
        <div v-if="isBusy">
            <b-skeleton-img></b-skeleton-img>
        </div>
        <div v-else>
            <apexchart :key="componentKey" :width="chartWidth" :height="height" type="bar" :options="barChartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
import DataSource from '@/models/DataSource/DataSource';

export default {
    props: {
        id: {
            default: "app-bar-chart",
            type: String,
        },
        dataSourceId: {
            default: "",
            type: [Number, String],
        },
        dataSourceValue: {
            default: "",
            type: [Number, String],
        },
        chartLabel: {
            default: "",
            type: [Number, String],
        },
        chartValue: {
            default: "",
            type: [Number, String],
        },
        chartOptions : 
        {
            type: Object,
        },
        dataChart : 
        {
            default: function() {return null;},
            type: Array,
        },
        chartSeries : 
        {
            default: function() {return null;},
            type: Array,
        },
        chartData : 
        {
            default: function() {return null;},
            type: Array,
        },
        height: {
            default: 200,
            type: Number,
        },
        decimalNumber: {
            default: 2,
            type: Number,
        }
    },
    data() {
        return {
            series : [{
                    name : '',
                    data : []
            }],
            width: 200,
            categories: [],
            title : '',
            isBusy : false,
            barChartOptions: {
                chart: {
                    id: this.id,
                    toolbar: {
                        show: false,
                    },
                },
                title: {
                    text: ''
                },
                xaxis: {
                    categories: [],
                    labels: {
                        show: this.showXAxisLabel,
                    },
                    labels: {
                        rotate: -90
                    },
                },
                yaxis: {
                    labels: {
                        show: this.showYAxisLabel,
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (value) {
                        if (isNaN(value)) {
                            return "Invalid number";
                        }

                        const formatter = new Intl.NumberFormat('en-US', {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                            useGrouping: true
                        });

                        return formatter.format(value);
                    },
                },
            },
            chartWidth: this.width,
            componentKey: 0,
        }
    },
    mounted() {
        if (this.dataSourceId != null && this.dataSourceId != "" && this.dataSourceId != undefined) {
            this.getDataSource();
        } else if (this.dataChart != null) {
            this.setDataChart(this.dataChart);
        } else if (this.chartSeries != null) {
            this.series = this.chartSeries;
        }
        this.chartWidth = "100%";
    },
    methods: {
        updateChart() {
            if (this.barChartOptions != null && this.barChartOptions != undefined) {
                this.barChartOptions.series = this.series;

                if (this.chartOptions.chart != null && this.chartOptions.chart != undefined)
                    this.barChartOptions.chart.background = this.chartOptions.chart.background;

                if (this.barChartOptions.xaxis != null && this.barChartOptions.xaxis != undefined) {
                    this.barChartOptions.xaxis.categories = this.categories;
                    if (this.chartOptions.xaxis != null && this.chartOptions.xaxis != undefined) {
                        if (this.chartOptions.xaxis.labels != null && this.chartOptions.xaxis.labels != undefined) {
                            this.barChartOptions.xaxis.labels.show = this.showXAxisLabel;
                            this.barChartOptions.xaxis.labels.style = this.chartOptions.xaxis.labels.style;
                        }
                    }
                }

                if (this.barChartOptions.yaxis != null && this.barChartOptions.yaxis != undefined) {
                    if (this.chartOptions.yaxis != null && this.chartOptions.yaxis != undefined) {
                        if (this.chartOptions.yaxis.labels != null && this.chartOptions.yaxis.labels != undefined) {
                            this.barChartOptions.yaxis.labels.formatter = this.chartOptions.yaxis.labels.formatter;
                            this.barChartOptions.yaxis.labels.style = this.chartOptions.yaxis.labels.style;
                        }
                    }
                    
                    this.barChartOptions.yaxis.labels.show = this.showYAxisLabel;
                }

                this.componentKey += 1;
            }
        },
        getDataSource() {
            this.isBusy = true;
			DataSource.getData(this, this.dataSourceId)
            .then(result => { 
                if (Array.isArray(result)) {
                    if (result.length > 0) {
                        
                        const labels = result.map(data => data[this.chartLabel]);
                        const values = result.map(data => parseFloat(data[this.chartValue]).toFixed(this.decimalNumber));

                        this.series = [{ name : '', data : values }];
                        this.categories = labels;
                    }
                }
                this.isBusy = false;
            })
            .catch(error => { 
                this.isBusy = false; 
            });
        },
        setDataChart(newValue) {
            if (newValue != null) {
                if (Array.isArray(newValue)) {
                    if (newValue.length > 0) {
                        const labels = newValue.map(data => data[this.chartLabel]);
                        const values = newValue.map(data =>parseFloat(data[this.chartValue]).toFixed(this.decimalNumber));
                        
                        this.series = [{ name : '', data : values }];
                        this.categories = labels;
                    }
                }
            }
        }
    },
    computed: {
        showXAxisLabel() {
            if (this.chartOptions.xaxisLabel != null && this.chartOptions.xaxisLabel != undefined) {
                return this.chartOptions.xaxisLabel;
            }
            return true;
        },
        showYAxisLabel() {
            if (this.chartOptions.yaxisLabel != null && this.chartOptions.yaxisLabel != undefined) {
                return this.chartOptions.yaxisLabel;
            }
            return true;
        },
    },
    watch: {
        width(newValue) {
            this.chartWidth = newValue;
        },
        series(newValue) {
            this.updateChart();
        },
        categories(newValue) {
            this.updateChart();
        },
        chartSeries: {
            handler: function(newValue, oldVal) {
                this.series = newValue;
            },
            deep: true
        },
        dataChart(newValue) {
            this.setDataChart(newValue);
        },
        chartOptions: {
            handler: function(newVal, oldVal) {
                this.updateChart();
            },
            deep: true
        },
    }
}
</script>